import React from "react";

// libs
import { Row, Spin, Icon, Col } from "antd";
// Styles
import { Card } from "../../styles";

// Components
import useKpiContext from "../../../../hooks/useKpiContext";

//Services
import { formatNumberAbbreviated } from "../../../../utils/numberUtils";

//Icons

const KpiCostDaily = () => {
  const { kpiCostDaily: kpiData, updateKpiSelected } = useKpiContext();

  return (
    <Card
      xs={23}
      sm={23}
      md={23}
      lg={7}
      xl={7}
      className={kpiData.isSelected ? " border-green" : ""}
      onClick={() =>
        !kpiData.isLoading ? updateKpiSelected("CUSTO_DIARIO") : null
      }
    >
      <Spin spinning={kpiData.isLoading} size="small">
        <div className="header">
          <span>
            {kpiData.data.error ? (
              <Icon
                type="exclamation-circle"
                className="iconError"
                theme="filled"
              />
            ) : null}
            CUSTO DIÁRIO
          </span>
          <span></span>
        </div>

        <div className="content">
          <Row style={{ width: "100%" }} type="flex" justify="space-between">
            <Col span={8}>
              <h3>Custo Total</h3>
              <span className="span-font">
                <b>
                  {kpiData?.data?.kpiValue == null
                    ? "-"
                    : formatNumberAbbreviated(
                        kpiData.data?.parameters?.AnimalDailyTotalCost || 0,
                      )}
                  /cab
                </b>
              </span>
            </Col>
            <Col span={8}>
              <h3>Custo Dieta</h3>
              <span className="span-font">
                <b>
                  {kpiData?.data?.kpiValue == null
                    ? "-"
                    : formatNumberAbbreviated(
                        kpiData?.data?.parameters?.AnimalDailyDietCost || 0,
                      )}
                  /cab
                </b>
              </span>
            </Col>
            <Col span={8}>
              <h3>Custo Adm/Operac.</h3>
              <span className="span-font">
                <b>
                  {kpiData?.data?.kpiValue == null
                    ? "-"
                    : formatNumberAbbreviated(
                        kpiData.data?.parameters
                          ?.AnimalDailyFixedAndOperationalCost || 0,
                      )}
                  /cab
                </b>
              </span>
            </Col>
          </Row>
        </div>
      </Spin>
      {!kpiData?.data?.isComplete ? <div className="banner-image" /> : null}
    </Card>
  );
};

export default KpiCostDaily;
